// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1440 320\"><path fill=\"%23ffffff\" fill-opacity=\"0.1\" d=\"M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 1200 120%27 preserveAspectRatio=%27none%27%3E%3Cpath d=%27M0,40 C150,80 350,0 600,40 C850,80 1050,10 1200,40 L1200,120 L0,120 Z%27 fill=%27%23ffffff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 1200 120%27 preserveAspectRatio=%27none%27%3E%3Cpath d=%27M0,60 C200,20 400,90 600,55 C800,20 1000,85 1200,50 L1200,120 L0,120 Z%27 fill=%27%23d4af37%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1440 320\"><path fill=\"%23ffffff\" fill-opacity=\"0.05\" d=\"M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HomePage Styles - أنماط الصفحة الرئيسية */

/* Hero Section - قسم البطل */
.hero {
  background: var(--gradient-primary);
  color: var(--bg-white);
  padding: 120px 0;
  text-align: center;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom;
  background-size: cover;
  opacity: 0.3;
  z-index: 0;
}

.hero-with-3d {
  min-height: min(92vh, 820px);
  display: flex;
  align-items: center;
  background:
    radial-gradient(ellipse 80% 60% at 80% 15%, rgba(212, 175, 55, 0.18), transparent 55%),
    linear-gradient(145deg, #0a2540 0%, #1a365d 42%, #1e4a7a 72%, #1d4ed8 100%);
}

.hero-with-3d::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(10, 37, 64, 0.55) 0%, rgba(10, 37, 64, 0.28) 45%, rgba(10, 37, 64, 0.12) 100%);
  z-index: 0;
  pointer-events: none;
}

.hero-waves {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.hero-wave-layer {
  position: absolute;
  left: 0;
  bottom: -8%;
  width: 200%;
  height: 55%;
  opacity: 0.18;
  background-repeat: repeat-x;
  background-size: 50% 100%;
  animation: waveDrift 18s linear infinite;
}

.hero-wave-a {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.hero-wave-b {
  bottom: -18%;
  opacity: 0.12;
  animation-duration: 26s;
  animation-direction: reverse;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.hero-content {
  position: relative;
  z-index: 2;
}

.animated-stat-bar {
  display: block;
  width: 42px;
  height: 3px;
  margin: 0.65rem auto 0;
  border-radius: 999px;
  background: var(--gradient-gold);
  transform-origin: center;
  transform: scaleX(0.35);
  opacity: 0.55;
  transition: transform 0.7s var(--motion-ease), opacity 0.7s ease;
}

.animated-stat.is-started .animated-stat-bar {
  transform: scaleX(1);
  opacity: 1;
}

.hero-logo {
  margin-bottom: 2rem;
  animation: fadeInUp 1s ease 0.1s both;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-logo-image {
  max-width: 600px;
  max-height: 300px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
}

.hero-logo-image:hover {
  transform: scale(1.05);
}

.hero-title {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--bg-white);
  text-shadow: 0 8px 28px rgba(0, 0, 0, 0.35), 2px 2px 4px rgba(0, 0, 0, 0.25);
  animation: fadeInUp 1s ease 0.2s both;
  letter-spacing: -0.02em;
}

.hero-tagline {
  font-size: 1.5rem;
  margin-bottom: 2.5rem;
  color: var(--bg-white);
  opacity: 0.95;
  animation: fadeInUp 1s ease 0.2s both;
}

.hero-stats {
  display: flex;
  gap: 3rem;
  justify-content: center;
  flex-wrap: wrap;
  margin: 3rem 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  animation: fadeInUp 1s ease 0.3s both;
  transform: translateZ(0);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.hero-stat-item {
  text-align: center;
  min-width: 120px;
}

.hero-stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--secondary-light-gold);
  margin-bottom: 0.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-stat-label {
  font-size: 1rem;
  color: var(--bg-white);
  opacity: 0.95;
  font-weight: 500;
}

.hero-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
  animation: fadeInUp 1s ease 0.4s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* About Section - قسم عن الشركة */
.about-section {
  padding: 80px 0;
  background-color: var(--bg-white);
}

.about-logo-section {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem 0;
}

.about-logo-image {
  max-width: 500px;
  max-height: 250px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
  transition: transform 0.3s ease;
}

.about-logo-image:hover {
  transform: scale(1.05);
}

.about-content {
  max-width: 1200px;
  margin: 0 auto;
}

.about-content-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

.about-text {
  font-size: 1.1rem;
  line-height: 2;
  color: var(--text-dark-gray);
  text-align: center;
}

.about-images {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.about-images-3d {
  perspective: 1200px;
}

.transport-image {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.45s var(--motion-ease), box-shadow 0.45s ease;
  transform-style: preserve-3d;
}

.transport-image::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, rgba(14, 116, 144, 0.15), rgba(26, 54, 93, 0.45));
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.transport-image:hover {
  transform: translateY(-8px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);
}

.transport-image:hover::after {
  opacity: 1;
}

.transport-tilt:nth-child(1):hover {
  transform: translateY(-10px) rotateY(-8deg) rotateX(4deg) scale(1.02);
  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.28);
}

.transport-tilt:nth-child(2):hover {
  transform: translateY(-10px) rotateY(0deg) rotateX(6deg) scale(1.02);
  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.28);
}

.transport-tilt:nth-child(3):hover {
  transform: translateY(-10px) rotateY(8deg) rotateX(4deg) scale(1.02);
  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.28);
}

.transport-image img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
  transition: transform 1.1s var(--motion-ease);
}

.transport-image:hover img {
  transform: scale(1.08);
}

.transport-image span {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  background: linear-gradient(to top, rgba(10, 37, 64, 0.95), transparent);
  color: var(--bg-white);
  padding: 1.5rem 1rem 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 1.1rem;
}

/* Official credentials / commercial registry */
.about-credentials {
  margin-top: 3.5rem;
  padding: 2rem 1.5rem;
  border-top: 1px solid rgba(10, 37, 64, 0.12);
  background:
    linear-gradient(160deg, rgba(10, 37, 64, 0.04), transparent 55%),
    var(--bg-white);
}

.about-credentials-title {
  text-align: center;
  color: var(--primary-dark-blue);
  font-size: 1.45rem;
  margin: 0 0 0.75rem;
}

.about-credentials-intro {
  text-align: center;
  max-width: 720px;
  margin: 0 auto 1.75rem;
  color: var(--text-dark-gray);
  line-height: 1.8;
}

.about-credentials-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 2rem;
  align-items: start;
  max-width: 1000px;
  margin: 0 auto;
}

.about-legal-name {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0 0 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(10, 37, 64, 0.1);
}

.about-legal-name span {
  font-size: 0.9rem;
  color: var(--footer-medium-gray, #666);
}

.about-legal-name strong {
  font-size: 1.15rem;
  color: var(--primary-dark-blue);
  line-height: 1.5;
}

.about-credentials-list {
  margin: 0;
}

.about-credentials-row {
  display: grid;
  grid-template-columns: minmax(8rem, 38%) 1fr;
  gap: 0.75rem 1rem;
  padding: 0.65rem 0;
  border-bottom: 1px dashed rgba(10, 37, 64, 0.1);
}

.about-credentials-row dt {
  margin: 0;
  font-weight: 600;
  color: var(--primary-dark-blue);
  font-size: 0.95rem;
}

.about-credentials-row dd {
  margin: 0;
  color: var(--text-dark-gray);
  line-height: 1.6;
}

.about-certificate {
  margin: 0;
  text-align: center;
}

.about-certificate a {
  display: block;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(10, 37, 64, 0.14);
  border: 1px solid rgba(10, 37, 64, 0.12);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.about-certificate a:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(10, 37, 64, 0.2);
}

.about-certificate img {
  width: 100%;
  height: auto;
  display: block;
  background: #f7f7f5;
}

.about-certificate figcaption {
  margin-top: 0.75rem;
  font-size: 0.9rem;
  color: var(--footer-medium-gray, #666);
}

@media (max-width: 800px) {
  .about-credentials-grid {
    grid-template-columns: 1fr;
  }

  .about-credentials-row {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }
}

/* Services Section - قسم الخدمات */
.services-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.services-grid > .stagger-item {
  min-height: 260px;
  height: 100%;
}

.service-card {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-top: 4px solid var(--button-medium-blue);
  text-decoration: none;
  color: inherit;
  display: block;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.service-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  display: block;
}

.service-card h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.service-card p {
  color: var(--footer-medium-gray);
  line-height: 1.8;
}

.regions-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.regions-intro {
  max-width: 820px;
  margin: 0 auto 2.5rem;
  text-align: center;
  line-height: 1.9;
  color: var(--text-dark-gray);
}

.regions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
  perspective: 1100px;
}

.region-card {
  background: var(--bg-white);
  padding: 1.75rem;
  border-radius: 12px;
  box-shadow: 0 5px 20px var(--shadow-color);
  border-right: 4px solid transparent;
  text-decoration: none;
  color: inherit;
  display: block;
  transform-style: preserve-3d;
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s ease;
}

.region-card:hover {
  transform: translateY(-8px) rotateX(4deg) rotateY(-3deg);
  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.2);
}

.region-card.interactive-lift::before {
  background: var(--gradient-maritime);
}

.region-card h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 0.75rem;
  font-size: 1.25rem;
}

.region-card p {
  color: var(--footer-medium-gray);
  line-height: 1.8;
  margin: 0;
}

/* Borders Section - قسم المعابر */
.borders-section {
  padding: 80px 0;
  background-color: var(--bg-white);
}

.borders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.border-card {
  background: linear-gradient(135deg, var(--section-light-gray) 0%, var(--bg-white) 100%);
  padding: 0;
  border-radius: 12px;
  box-shadow: 0 5px 20px var(--shadow-color);
  border-right: 4px solid var(--secondary-light-gold);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.border-card:hover {
  transform: translateX(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.border-card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  position: relative;
}

.border-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.border-card:hover .border-card-image img {
  transform: scale(1.1);
}

.border-card h3 {
  color: var(--primary-dark-blue);
  margin: 1.5rem 2.5rem 1.5rem;
  font-size: 1.5rem;
  text-align: center;
}

.border-card ul {
  list-style: none;
  padding: 0 2.5rem 2.5rem;
}

.border-card ul li {
  padding: 0.8rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: var(--text-dark-gray);
  position: relative;
  padding-right: 1.5rem;
}

.border-card ul li::before {
  content: '✓';
  position: absolute;
  right: 0;
  color: var(--button-medium-blue);
  font-weight: bold;
}

.border-card ul li:last-child {
  border-bottom: none;
}

/* Contact Section - قسم الاتصال */
.contact-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 3rem;
  margin-top: 3rem;
}

.contact-info {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  height: fit-content;
}

.contact-info h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  color: var(--text-dark-gray);
}

.contact-icon {
  font-size: 1.5rem;
  width: 40px;
  text-align: center;
}

/* Contact Form - نموذج الاتصال */
.contact-form {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--primary-dark-blue);
  font-weight: 600;
  font-size: 1rem;
}

.form-hint {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: var(--footer-medium-gray);
  font-style: italic;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid var(--section-light-gray);
  border-radius: 5px;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s ease;
  background-color: var(--bg-white);
  color: var(--text-dark-gray);
}

.form-group select {
  font-size: 0.9rem !important;
  font-weight: 500;
  line-height: 1.4;
}

.form-group select option {
  font-size: 0.9rem !important;
  padding: 0.4rem;
  font-weight: 500;
  line-height: 1.4;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--button-medium-blue);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.contact-form .btn {
  width: 100%;
  margin-top: 1rem;
}

/* Responsive Design - التصميم المتجاوب */
@media (max-width: 968px) {
  .about-content-wrapper {
    grid-template-columns: 1fr;
  }

  .about-images {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .contact-content {
    grid-template-columns: 1fr;
  }

  .hero-title {
    font-size: 3rem;
  }

  .hero-tagline {
    font-size: 1.3rem;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 80px 0;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-tagline {
    font-size: 1.1rem;
  }

  .hero-stats {
    gap: 1.5rem;
    padding: 1.5rem;
    margin: 2rem 0;
  }

  .hero-stat-item {
    min-width: 100px;
  }

  .hero-stat-number {
    font-size: 2rem;
  }

  .hero-stat-label {
    font-size: 0.9rem;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .hero-buttons .btn {
    width: 100%;
    max-width: 300px;
  }

  .about-logo-image {
    max-width: 300px;
    max-height: 150px;
  }

  .about-images {
    grid-template-columns: 1fr;
  }

  .transport-image img {
    height: 200px;
  }

  .about-section,
  .services-section,
  .borders-section,
  .contact-section {
    padding: 60px 0;
  }

  .services-grid,
  .borders-grid {
    grid-template-columns: 1fr;
  }

  .service-card,
  .border-card {
    padding: 2rem;
  }

  .contact-info,
  .contact-form {
    padding: 2rem;
  }
}

/* Statistics Section - قسم الإحصائيات */
.statistics-section {
  padding: 80px 0;
  background: var(--gradient-primary);
  color: var(--bg-white);
  position: relative;
  overflow: hidden;
}

.statistics-section::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat bottom;
  background-size: cover;
  opacity: 0.3;
}

.statistics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2.5rem;
  text-align: center;
  position: relative;
  z-index: 1;
}

.stat-item {
  padding: 2.5rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.stat-number {
  font-size: 4rem;
  font-weight: 700;
  color: var(--secondary-light-gold);
  margin-bottom: 0.75rem;
  line-height: 1;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  display: block;
}

.stat-label {
  font-size: 1.3rem;
  color: var(--bg-white);
  opacity: 0.95;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Quick Quote Section - قسم طلب عرض سعر */
.quick-quote-section {
  padding: 80px 0;
  background-color: var(--bg-white);
}

.quote-form {
  max-width: 900px;
  margin: 0 auto;
  background-color: var(--section-light-gray);
  padding: 3rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.quote-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.quote-form .form-group label {
  font-size: 1rem;
  font-weight: 600;
}

.quote-form .form-group input {
  font-size: 1rem;
  padding: 12px 15px;
}

.quote-form .form-group select {
  font-size: 0.9rem !important;
  padding: 12px 15px;
  font-weight: 500;
  line-height: 1.4;
}

.quote-form .form-group select option {
  font-size: 0.9rem !important;
  padding: 0.4rem;
  font-weight: 500;
  line-height: 1.4;
}

/* Calculator Section - الآلة الحاسبة */
.calculator-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.tariff-download-banner {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem;
  background: linear-gradient(135deg, var(--primary-dark-blue) 0%, var(--button-medium-blue) 100%);
  border-radius: 10px;
  color: var(--bg-white);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.tariff-download-banner p {
  margin-bottom: 1rem;
  font-size: 1.1rem;
  color: var(--bg-white);
}

.tariff-download-banner .btn {
  margin-top: 0.5rem;
}

/* Tariff Importer Section */
.tariff-importer-section {
  margin: 3rem 0;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.importer-details {
  background-color: var(--bg-white);
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.importer-summary {
  padding: 1.5rem;
  background: linear-gradient(135deg, var(--primary-dark-blue) 0%, var(--button-medium-blue) 100%);
  color: var(--bg-white);
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  list-style: none;
  user-select: none;
}

.importer-summary::-webkit-details-marker {
  display: none;
}

.importer-summary::before {
  content: '▶';
  display: inline-block;
  margin-left: 0.5rem;
  transition: transform 0.3s ease;
}

.importer-details[open] .importer-summary::before {
  transform: rotate(90deg);
}

.importer-content {
  padding: 2rem;
}

.import-instructions {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: var(--section-light-gray);
  border-radius: 8px;
  border-right: 4px solid var(--button-medium-blue);
}

.import-instructions h4 {
  color: var(--primary-dark-blue);
  margin-bottom: 1rem;
}

.import-instructions ol {
  padding-right: 1.5rem;
  color: var(--text-dark-gray);
  line-height: 2;
}

.import-instructions li {
  margin-bottom: 0.5rem;
}

.import-instructions strong {
  color: var(--primary-dark-blue);
}

.calculator-container {
  max-width: 800px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.calculator-form {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.hs-search-group {
  position: relative;
}

.hs-search-box {
  position: relative;
}

.hs-suggestions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  max-height: 280px;
  overflow-y: auto;
  background: var(--bg-white);
  border: 1px solid var(--border-light, #d0d7de);
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.hs-suggestion-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: transparent;
  text-align: inherit;
  cursor: pointer;
  color: var(--text-dark-gray);
}

.hs-suggestion-item:last-child {
  border-bottom: 0;
}

.hs-suggestion-item:hover,
.hs-suggestion-item:focus {
  background: rgba(0, 119, 182, 0.08);
  outline: none;
}

.hs-suggestion-code {
  font-weight: 700;
  color: var(--primary-dark-blue);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.hs-suggestion-desc {
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--text-dark-gray);
}

.hs-suggestion-empty {
  padding: 0.9rem 1rem;
  color: var(--text-dark-gray);
  opacity: 0.8;
}

.hs-search-hint,
.hs-selected-desc,
.hs-chapter-note {
  margin: 0.55rem 0 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--text-dark-gray);
}

.hs-selected-desc {
  font-weight: 600;
  color: var(--primary-dark-blue);
}

.hs-chapter-note {
  padding: 0.65rem 0.8rem;
  background: rgba(0, 119, 182, 0.06);
  border-radius: 6px;
  border-right: 3px solid var(--button-medium-blue, #0077b6);
}

.dark-mode .hs-suggestions {
  background: #1b2430;
  border-color: #334155;
}

.dark-mode .hs-suggestion-item {
  color: #e2e8f0;
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.dark-mode .hs-suggestion-item:hover,
.dark-mode .hs-suggestion-item:focus {
  background: rgba(56, 189, 248, 0.12);
}

.dark-mode .hs-suggestion-code,
.dark-mode .hs-selected-desc {
  color: #7dd3fc;
}

.dark-mode .hs-chapter-note {
  background: rgba(56, 189, 248, 0.1);
}

.calculator-form .form-group select {
  font-size: 0.9rem !important;
  font-weight: 500;
  padding: 12px 15px;
  line-height: 1.4;
}

.calculator-form .form-group select option {
  font-size: 0.9rem !important;
  padding: 0.4rem;
  font-weight: 500;
  line-height: 1.4;
}

.calculator-result {
  background: var(--gradient-primary);
  color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 8px 25px var(--shadow-color);
  height: fit-content;
}

.calculator-result h3 {
  color: var(--bg-white);
  margin-bottom: 1.5rem;
}

.result-amount {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--secondary-light-gold);
  margin-bottom: 1rem;
}

.result-amount.is-pulsing {
  animation: goldPulse 0.85s var(--motion-ease) 1;
}

.hs-search-group .hs-search-box input:focus {
  outline: none;
  border-color: var(--accent-sky) !important;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.22), 0 0 18px rgba(212, 175, 55, 0.18);
}

@media (prefers-reduced-motion: reduce) {
  .hero-wave-layer,
  .result-amount.is-pulsing,
  .transport-image img {
    animation: none !important;
    transition: none !important;
  }
}

.currency-label {
  font-size: 1.2rem;
  font-weight: 400;
  margin-right: 0.5rem;
  opacity: 0.9;
}

.result-note {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 1rem 0 0 0;
}

.result-breakdown {
  margin: 1.5rem 0;
  padding: 1.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.breakdown-item {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.breakdown-item:last-child {
  border-bottom: none;
}

.breakdown-item.breakdown-total {
  font-weight: 600;
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 2px solid rgba(255, 255, 255, 0.3);
}

.breakdown-label {
  color: rgba(255, 255, 255, 0.9);
}

.breakdown-value {
  color: var(--secondary-light-gold);
  font-weight: 600;
}


/* Documents Section - دليل الوثائق */
.documents-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.document-card {
  background-color: var(--bg-white);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  border-top: 4px solid var(--button-medium-blue);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.document-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.document-icon {
  font-size: 3rem;
  text-align: center;
  margin-bottom: 1rem;
  display: block;
}

.document-card h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  text-align: center;
  font-weight: 600;
}

.document-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.document-card ul li {
  padding: 0.8rem 0;
  padding-right: 1.5rem;
  position: relative;
  color: var(--text-dark-gray);
  border-bottom: 1px solid var(--section-light-gray);
  font-size: 0.95rem;
}

.document-card ul li::before {
  content: '✓';
  position: absolute;
  right: 0;
  color: var(--button-medium-blue);
  font-weight: bold;
  font-size: 1.1rem;
}

.document-card ul li:last-child {
  border-bottom: none;
}

/* Legacy support */
.document-category {
  background-color: var(--bg-white);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  border-top: 4px solid var(--button-medium-blue);
}

.document-category h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
}

.document-category ul {
  list-style: none;
  padding: 0;
}

.document-category ul li {
  padding: 0.8rem 0;
  padding-right: 1.5rem;
  position: relative;
  color: var(--text-dark-gray);
  border-bottom: 1px solid var(--section-light-gray);
}

.document-category ul li::before {
  content: '📄';
  position: absolute;
  right: 0;
}

.document-category ul li:last-child {
  border-bottom: none;
}

/* Borders Map - خريطة المعابر */
.borders-map-container {
  margin-bottom: 3rem;
}

.syria-map {
  position: relative;
  width: 100%;
  height: 400px;
  background: linear-gradient(135deg, #e8f4f8 0%, #d4e8f0 100%);
  border-radius: 10px;
  margin: 0 auto;
  border: 2px solid var(--button-medium-blue);
}

.map-point {
  position: absolute;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.map-point:hover {
  transform: scale(1.2);
}

.map-marker {
  font-size: 2rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.map-tooltip {
  position: absolute;
  bottom: 100%;
  right: 50%;
  transform: translateX(50%);
  background-color: var(--primary-dark-blue);
  color: var(--bg-white);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.map-point:hover .map-tooltip {
  opacity: 1;
}

.map-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  border: 5px solid transparent;
  border-top-color: var(--primary-dark-blue);
}

/* Testimonials Section - شهادات العملاء */
.testimonials-section {
  padding: 80px 0;
  background-color: var(--bg-white);
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.testimonial-card {
  background-color: var(--section-light-gray);
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  border-right: 4px solid var(--secondary-light-gold);
}

.testimonial-rating {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.testimonial-text {
  color: var(--text-dark-gray);
  line-height: 1.8;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.testimonial-author strong {
  color: var(--primary-dark-blue);
  font-size: 1.1rem;
}

.testimonial-author span {
  color: var(--footer-medium-gray);
  font-size: 0.9rem;
}

/* Certifications Section - الشهادات */
.certifications-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.certifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.certification-item {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.certification-item:hover {
  transform: translateY(-5px);
}

.cert-icon {
  font-size: 3.5rem;
  margin-bottom: 1rem;
}

.certification-item h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 0.5rem;
}

.certification-item p {
  color: var(--footer-medium-gray);
  margin: 0;
}

/* Partners Section - الشركاء */
.partners-section {
  padding: 80px 0;
  background-color: var(--bg-white);
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.partner-logo {
  background-color: var(--bg-white);
  border-radius: 12px;
  padding: 1.75rem 1.25rem;
  text-align: center;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.partner-logo:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
}

.partner-emoji {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: var(--section-light-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.25rem;
}

.partner-logo p {
  margin: 0;
  font-weight: 600;
  color: var(--primary-dark-blue);
  line-height: 1.4;
}

/* Team Section - فريق العمل */
.team-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  margin: 0;
  position: relative;
  /* منع تجمد الشاشة على Android */
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  /* منع التجميد على Android */
  transform: none;
  will-change: auto;
  -webkit-transform: none;
}

.team-member {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  /* منع فتح القائمة عند اللمس */
  touch-action: manipulation;
  pointer-events: auto;
}

.team-member:hover {
  transform: translateY(-5px);
}

/* على الموبايل: تعطيل hover effect */
@media (max-width: 768px) {
  .team-member:hover {
    transform: none;
  }
  
  .team-member {
    touch-action: pan-y;
    /* إزالة transition على الموبايل لمنع التجميد */
    transition: none;
  }
  
  /* منع تجمد الشاشة عند التمرير */
  .team-section {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    /* إزالة أي transform أو will-change */
    transform: none;
    will-change: auto;
  }
  
  .team-grid {
    /* تبسيط grid على الموبايل */
    transform: none;
    will-change: auto;
  }
}

.member-avatar {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.team-member h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 0.5rem;
}

.member-role {
  color: var(--button-medium-blue);
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.member-bio {
  color: var(--footer-medium-gray);
  font-size: 0.9rem;
  margin: 0;
}

/* News Section - الأخبار */
.news-section {
  padding: 80px 0;
  background-color: var(--bg-white);
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.news-card {
  background-color: var(--section-light-gray);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.news-card:hover {
  transform: translateY(-5px);
}

.news-date {
  color: var(--button-medium-blue);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.news-card h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.news-card p {
  color: var(--text-dark-gray);
  line-height: 1.8;
  margin-bottom: 1rem;
}

.news-link {
  color: var(--button-medium-blue);
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
}

.news-link:hover {
  color: var(--primary-dark-blue);
}

/* FAQ Section - الأسئلة الشائعة */
.faq-section {
  padding: 80px 0;
  background-color: var(--section-light-gray);
}

.faq-list {
  max-width: 900px;
  margin: 0 auto;
}

.faq-item {
  background-color: var(--bg-white);
  margin-bottom: 1rem;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.faq-question {
  padding: 1.5rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--primary-dark-blue);
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.faq-question:hover {
  background-color: var(--section-light-gray);
}

.faq-icon {
  font-size: 1.5rem;
  color: var(--button-medium-blue);
  font-weight: bold;
  transition: transform 0.3s ease;
}

.faq-item.open .faq-icon {
  transform: rotate(180deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 1.5rem;
}

.faq-item.open .faq-answer {
  max-height: 500px;
  padding: 0 1.5rem 1.5rem;
}

.faq-answer p {
  color: var(--text-dark-gray);
  line-height: 1.8;
  margin: 0;
}

/* Responsive Design - التصميم المتجاوب */
@media (max-width: 968px) {
  .contact-content {
    grid-template-columns: 1fr;
  }

  .hero-title {
    font-size: 3rem;
  }

  .hero-tagline {
    font-size: 1.3rem;
  }

  .calculator-container {
    grid-template-columns: 1fr;
  }

  .quote-form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 80px 0;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-tagline {
    font-size: 1.1rem;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .hero-buttons .btn {
    width: 100%;
    max-width: 300px;
  }

  .about-section,
  .services-section,
  .borders-section,
  .contact-section,
  .statistics-section,
  .quick-quote-section,
  .calculator-section,
  .documents-section,
  .testimonials-section,
  .certifications-section,
  .partners-section,
  .team-section,
  .news-section,
  .faq-section {
    padding: 60px 0;
  }

  .services-grid,
  .borders-grid,
  .statistics-grid,
  .testimonials-grid,
  .certifications-grid,
  .partners-grid,
  .team-grid,
  .news-grid,
  .documents-grid {
    grid-template-columns: 1fr;
  }

  .service-card,
  .border-card,
  .contact-info,
  .contact-form,
  .quote-form,
  .calculator-form {
    padding: 2rem;
  }

  .stat-number {
    font-size: 2.5rem;
  }

  .syria-map {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 60px 0;
  }

  .about-logo-image {
    max-width: 250px;
    max-height: 125px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-tagline {
    font-size: 1rem;
  }

  .hero-stats {
    gap: 1rem;
    padding: 1rem;
    margin: 1.5rem 0;
  }

  .hero-stat-item {
    min-width: 80px;
  }

  .hero-stat-number {
    font-size: 1.5rem;
  }

  .hero-stat-label {
    font-size: 0.8rem;
  }

  .hero-buttons {
    gap: 1rem;
  }

  .hero-buttons .btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .stat-number {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 1rem;
  }
}

/* تحسينات خاصة لأندرويد */
@media screen and (-webkit-min-device-pixel-ratio: 2) {
  .hero-stats,
  .stat-item {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}

/* تحسينات خاصة لآبل */
@supports (-webkit-touch-callout: none) {
  .hero-stats,
  .stat-item {
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  body {
    -webkit-overflow-scrolling: touch;
  }
}

/* تحسينات للشاشات الصغيرة جداً */
@media (max-width: 360px) {
  .hero-title {
    font-size: 1.75rem;
  }

  .hero-stats {
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .hero-stat-number {
    font-size: 1.25rem;
  }

  .hero-stat-label {
    font-size: 0.75rem;
  }

  .hero-tagline {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .service-card,
  .border-card,
  .contact-info,
  .contact-form,
  .quote-form,
  .calculator-form {
    padding: 1.5rem;
  }

  .stat-number {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 1rem;
  }

  .quote-form {
    padding: 2rem 1.5rem;
  }

  .result-amount {
    font-size: 2rem;
  }

  .syria-map {
    height: 250px;
  }
}

/* Dark Mode Styles - أنماط الوضع الداكن */
.dark-mode .hero {
  background: linear-gradient(135deg, #1a202c 0%, #2d3748 50%, #1a202c 100%);
}

.dark-mode .about-section,
.dark-mode .services-section,
.dark-mode .borders-section,
.dark-mode .testimonials-section,
.dark-mode .faq-section,
.dark-mode .certifications-section,
.dark-mode .news-section,
.dark-mode .team-section,
.dark-mode .partners-section,
.dark-mode .quick-quote-section,
.dark-mode .calculator-section,
.dark-mode .documents-section {
  background-color: var(--section-bg);
  color: var(--text-dark-gray);
}

.dark-mode .about-content-wrapper,
.dark-mode .service-card,
.dark-mode .region-card,
.dark-mode .border-card,
.dark-mode .testimonial-card,
.dark-mode .faq-item,
.dark-mode .certification-card,
.dark-mode .news-card,
.dark-mode .team-member,
.dark-mode .partner-logo,
.dark-mode .document-card {
  background-color: var(--section-light-gray);
  border-color: var(--border-light);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.dark-mode .contact-info,
.dark-mode .contact-form,
.dark-mode .quote-form,
.dark-mode .calculator-form {
  background-color: var(--section-light-gray);
  border-color: var(--border-light);
}

.dark-mode .form-group input,
.dark-mode .form-group textarea,
.dark-mode .form-group select {
  background-color: var(--section-bg);
  color: var(--text-dark-gray);
  border-color: var(--border-light);
}

.dark-mode .form-group input:focus,
.dark-mode .form-group textarea:focus,
.dark-mode .form-group select:focus {
  border-color: var(--accent-blue);
  background-color: var(--section-bg);
}

.dark-mode .calculator-result {
  background-color: var(--section-light-gray);
  border-color: var(--border-light);
}

.dark-mode .result-amount {
  color: var(--secondary-light-gold);
}

.dark-mode .breakdown-item {
  border-color: var(--border-light);
}

.dark-mode .faq-question {
  background-color: var(--section-light-gray);
  color: var(--text-dark-gray);
}

.dark-mode .faq-answer {
  background-color: var(--section-bg);
  color: var(--text-medium-gray);
}

.dark-mode .about-logo-image {
  filter: brightness(1.1);
}

.dark-mode .transport-image img,
.dark-mode .border-card-image img {
  opacity: 0.9;
}

.dark-mode .section-title {
  color: var(--primary-dark-blue);
}

.dark-mode .section-subtitle {
  color: var(--text-medium-gray);
}

.dark-mode .hero-stats {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.dark-mode .tariff-download-banner {
  background-color: var(--section-light-gray);
  border-color: var(--border-light);
}

.dark-mode .json-preview-section {
  background-color: var(--section-light-gray);
  border-color: var(--border-light);
}

.dark-mode .json-preview-section pre {
  background-color: var(--section-bg);
  color: var(--text-dark-gray);
}

.dark-mode .importer-details {
  background-color: var(--section-light-gray);
  border-color: var(--border-light);
}

.dark-mode .importer-summary {
  background-color: var(--section-light-gray);
  color: var(--text-dark-gray);
}

.dark-mode .importer-content {
  background-color: var(--section-bg);
}

.dark-mode .import-instructions {
  background-color: var(--section-light-gray);
  color: var(--text-dark-gray);
}

/* Extra maritime polish */
.quote-form-glow {
  position: relative;
  border: 1px solid rgba(56, 189, 248, 0.18);
  box-shadow: 0 12px 36px rgba(26, 54, 93, 0.1);
}

.document-card,
.border-card,
.testimonial-card,
.news-card,
.team-member,
.partner-logo {
  transition: transform 0.35s var(--motion-ease), box-shadow 0.35s ease;
}

.document-card:hover,
.testimonial-card:hover,
.news-card:hover,
.team-member:hover,
.partner-logo:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 30px rgba(26, 54, 93, 0.14);
}

.certification-card {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  border-top: 4px solid var(--secondary-light-gold);
  transition: transform 0.35s var(--motion-ease), box-shadow 0.35s ease;
}

.certification-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 30px rgba(26, 54, 93, 0.14);
}

.certification-icon {
  font-size: 3.2rem;
  margin-bottom: 1rem;
  display: block;
  animation: floatSoft 3.6s ease-in-out infinite;
}

.map-point {
  animation: mapPointPulse 2.4s ease-in-out infinite;
}

@keyframes mapPointPulse {
  0%,
  100% {
    filter: drop-shadow(0 0 0 rgba(212, 175, 55, 0));
  }
  50% {
    filter: drop-shadow(0 0 10px rgba(212, 175, 55, 0.55));
  }
}

.calculator-form {
  border: 1px solid rgba(56, 189, 248, 0.12);
}

.contact-form,
.contact-info {
  box-shadow: 0 12px 32px rgba(26, 54, 93, 0.08);
}

@media (prefers-reduced-motion: reduce) {
  .certification-icon,
  .map-point {
    animation: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/HomePage.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C,6BAA6B;AAC7B;EACE,mCAAmC;EACnC,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oEAAmd;EACnd,sBAAsB;EACtB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB;;+EAE6E;AAC/E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;8GAC4G;EAC5G,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yDAA0P;AAC5P;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,yDAA2P;AAC7P;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,4EAA4E;EAC5E,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;EACrC,wBAAwB;EACxB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qEAAqE;EACrE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qFAAqF;EACrF,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qEAAqE;EACrE,8CAA8C;AAChD;;AAEA;EACE,oEAAoE;EACpE,8CAA8C;AAChD;;AAEA;EACE,oEAAoE;EACpE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,UAAU;EACV,wEAAwE;EACxE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;EAC5C;;mBAEiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;EACrD,+CAA+C;EAC/C,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,4BAA4B;EAC5B,+EAA+E;AACjF;;AAEA;EACE,wDAAwD;EACxD,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uFAAuF;EACvF,UAAU;EACV,mBAAmB;EACnB,0CAA0C;EAC1C,mDAAmD;EACnD,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oEAAod;EACpd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,cAAc;EACd,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gGAAgG;EAChG,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gGAAgG;EAChG,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,8CAA8C;EAC9C,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,4CAA4C;EAC5C,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qEAAqE;AACvE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,iFAAiF;AACnF;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;;AAGA,qCAAqC;AACrC;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,0CAA0C;EAC1C,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,sCAAsC;IACtC,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;IAcE,eAAe;EACjB;;EAEA;;;;;;;;;IASE,0BAA0B;EAC5B;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE;;IAEE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;EACE;;IAEE,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,0CAA0C;AAC1C;EACE,0EAA0E;AAC5E;;AAEA;;;;;;;;;;;;EAYE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;EAWE,2CAA2C;EAC3C,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;;;;EAIE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;;EAGE,mCAAmC;EACnC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;;;EAGE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;;;;;;EAME,qEAAqE;AACvE;;AAEA;;;;;EAKE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,iDAAiD;EACjD,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;;IAEE,gDAAgD;EAClD;EACA;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* HomePage Styles - أنماط الصفحة الرئيسية */\n\n/* Hero Section - قسم البطل */\n.hero {\n  background: var(--gradient-primary);\n  color: var(--bg-white);\n  padding: 120px 0;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1440 320\"><path fill=\"%23ffffff\" fill-opacity=\"0.1\" d=\"M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z\"></path></svg>') no-repeat bottom;\n  background-size: cover;\n  opacity: 0.3;\n  z-index: 0;\n}\n\n.hero-with-3d {\n  min-height: min(92vh, 820px);\n  display: flex;\n  align-items: center;\n  background:\n    radial-gradient(ellipse 80% 60% at 80% 15%, rgba(212, 175, 55, 0.18), transparent 55%),\n    linear-gradient(145deg, #0a2540 0%, #1a365d 42%, #1e4a7a 72%, #1d4ed8 100%);\n}\n\n.hero-with-3d::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(90deg, rgba(10, 37, 64, 0.55) 0%, rgba(10, 37, 64, 0.28) 45%, rgba(10, 37, 64, 0.12) 100%);\n  z-index: 0;\n  pointer-events: none;\n}\n\n.hero-waves {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n  overflow: hidden;\n}\n\n.hero-wave-layer {\n  position: absolute;\n  left: 0;\n  bottom: -8%;\n  width: 200%;\n  height: 55%;\n  opacity: 0.18;\n  background-repeat: repeat-x;\n  background-size: 50% 100%;\n  animation: waveDrift 18s linear infinite;\n}\n\n.hero-wave-a {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,40 C150,80 350,0 600,40 C850,80 1050,10 1200,40 L1200,120 L0,120 Z' fill='%23ffffff'/%3E%3C/svg%3E\");\n}\n\n.hero-wave-b {\n  bottom: -18%;\n  opacity: 0.12;\n  animation-duration: 26s;\n  animation-direction: reverse;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,60 C200,20 400,90 600,55 C800,20 1000,85 1200,50 L1200,120 L0,120 Z' fill='%23d4af37'/%3E%3C/svg%3E\");\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n}\n\n.animated-stat-bar {\n  display: block;\n  width: 42px;\n  height: 3px;\n  margin: 0.65rem auto 0;\n  border-radius: 999px;\n  background: var(--gradient-gold);\n  transform-origin: center;\n  transform: scaleX(0.35);\n  opacity: 0.55;\n  transition: transform 0.7s var(--motion-ease), opacity 0.7s ease;\n}\n\n.animated-stat.is-started .animated-stat-bar {\n  transform: scaleX(1);\n  opacity: 1;\n}\n\n.hero-logo {\n  margin-bottom: 2rem;\n  animation: fadeInUp 1s ease 0.1s both;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hero-logo-image {\n  max-width: 600px;\n  max-height: 300px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\n  transition: transform 0.3s ease;\n}\n\n.hero-logo-image:hover {\n  transform: scale(1.05);\n}\n\n.hero-title {\n  font-size: 4rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: var(--bg-white);\n  text-shadow: 0 8px 28px rgba(0, 0, 0, 0.35), 2px 2px 4px rgba(0, 0, 0, 0.25);\n  animation: fadeInUp 1s ease 0.2s both;\n  letter-spacing: -0.02em;\n}\n\n.hero-tagline {\n  font-size: 1.5rem;\n  margin-bottom: 2.5rem;\n  color: var(--bg-white);\n  opacity: 0.95;\n  animation: fadeInUp 1s ease 0.2s both;\n}\n\n.hero-stats {\n  display: flex;\n  gap: 3rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin: 3rem 0;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  animation: fadeInUp 1s ease 0.3s both;\n  transform: translateZ(0);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.22);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n}\n\n.hero-stat-item {\n  text-align: center;\n  min-width: 120px;\n}\n\n.hero-stat-number {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--secondary-light-gold);\n  margin-bottom: 0.5rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.hero-stat-label {\n  font-size: 1rem;\n  color: var(--bg-white);\n  opacity: 0.95;\n  font-weight: 500;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  animation: fadeInUp 1s ease 0.4s both;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* About Section - قسم عن الشركة */\n.about-section {\n  padding: 80px 0;\n  background-color: var(--bg-white);\n}\n\n.about-logo-section {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 2rem 0;\n}\n\n.about-logo-image {\n  max-width: 500px;\n  max-height: 250px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));\n  transition: transform 0.3s ease;\n}\n\n.about-logo-image:hover {\n  transform: scale(1.05);\n}\n\n.about-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.about-content-wrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.about-text {\n  font-size: 1.1rem;\n  line-height: 2;\n  color: var(--text-dark-gray);\n  text-align: center;\n}\n\n.about-images {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.about-images-3d {\n  perspective: 1200px;\n}\n\n.transport-image {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  transition: transform 0.45s var(--motion-ease), box-shadow 0.45s ease;\n  transform-style: preserve-3d;\n}\n\n.transport-image::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(160deg, rgba(14, 116, 144, 0.15), rgba(26, 54, 93, 0.45));\n  opacity: 0;\n  transition: opacity 0.35s ease;\n  pointer-events: none;\n}\n\n.transport-image:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);\n}\n\n.transport-image:hover::after {\n  opacity: 1;\n}\n\n.transport-tilt:nth-child(1):hover {\n  transform: translateY(-10px) rotateY(-8deg) rotateX(4deg) scale(1.02);\n  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.28);\n}\n\n.transport-tilt:nth-child(2):hover {\n  transform: translateY(-10px) rotateY(0deg) rotateX(6deg) scale(1.02);\n  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.28);\n}\n\n.transport-tilt:nth-child(3):hover {\n  transform: translateY(-10px) rotateY(8deg) rotateX(4deg) scale(1.02);\n  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.28);\n}\n\n.transport-image img {\n  width: 100%;\n  height: 250px;\n  object-fit: cover;\n  display: block;\n  transition: transform 1.1s var(--motion-ease);\n}\n\n.transport-image:hover img {\n  transform: scale(1.08);\n}\n\n.transport-image span {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  background: linear-gradient(to top, rgba(10, 37, 64, 0.95), transparent);\n  color: var(--bg-white);\n  padding: 1.5rem 1rem 1rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n/* Official credentials / commercial registry */\n.about-credentials {\n  margin-top: 3.5rem;\n  padding: 2rem 1.5rem;\n  border-top: 1px solid rgba(10, 37, 64, 0.12);\n  background:\n    linear-gradient(160deg, rgba(10, 37, 64, 0.04), transparent 55%),\n    var(--bg-white);\n}\n\n.about-credentials-title {\n  text-align: center;\n  color: var(--primary-dark-blue);\n  font-size: 1.45rem;\n  margin: 0 0 0.75rem;\n}\n\n.about-credentials-intro {\n  text-align: center;\n  max-width: 720px;\n  margin: 0 auto 1.75rem;\n  color: var(--text-dark-gray);\n  line-height: 1.8;\n}\n\n.about-credentials-grid {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 2rem;\n  align-items: start;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.about-legal-name {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin: 0 0 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(10, 37, 64, 0.1);\n}\n\n.about-legal-name span {\n  font-size: 0.9rem;\n  color: var(--footer-medium-gray, #666);\n}\n\n.about-legal-name strong {\n  font-size: 1.15rem;\n  color: var(--primary-dark-blue);\n  line-height: 1.5;\n}\n\n.about-credentials-list {\n  margin: 0;\n}\n\n.about-credentials-row {\n  display: grid;\n  grid-template-columns: minmax(8rem, 38%) 1fr;\n  gap: 0.75rem 1rem;\n  padding: 0.65rem 0;\n  border-bottom: 1px dashed rgba(10, 37, 64, 0.1);\n}\n\n.about-credentials-row dt {\n  margin: 0;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  font-size: 0.95rem;\n}\n\n.about-credentials-row dd {\n  margin: 0;\n  color: var(--text-dark-gray);\n  line-height: 1.6;\n}\n\n.about-certificate {\n  margin: 0;\n  text-align: center;\n}\n\n.about-certificate a {\n  display: block;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(10, 37, 64, 0.14);\n  border: 1px solid rgba(10, 37, 64, 0.12);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.about-certificate a:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 28px rgba(10, 37, 64, 0.2);\n}\n\n.about-certificate img {\n  width: 100%;\n  height: auto;\n  display: block;\n  background: #f7f7f5;\n}\n\n.about-certificate figcaption {\n  margin-top: 0.75rem;\n  font-size: 0.9rem;\n  color: var(--footer-medium-gray, #666);\n}\n\n@media (max-width: 800px) {\n  .about-credentials-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .about-credentials-row {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n}\n\n/* Services Section - قسم الخدمات */\n.services-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.services-grid > .stagger-item {\n  min-height: 260px;\n  height: 100%;\n}\n\n.service-card {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border-top: 4px solid var(--button-medium-blue);\n  text-decoration: none;\n  color: inherit;\n  display: block;\n}\n\n.service-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.service-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  display: block;\n}\n\n.service-card h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.service-card p {\n  color: var(--footer-medium-gray);\n  line-height: 1.8;\n}\n\n.regions-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.regions-intro {\n  max-width: 820px;\n  margin: 0 auto 2.5rem;\n  text-align: center;\n  line-height: 1.9;\n  color: var(--text-dark-gray);\n}\n\n.regions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n  perspective: 1100px;\n}\n\n.region-card {\n  background: var(--bg-white);\n  padding: 1.75rem;\n  border-radius: 12px;\n  box-shadow: 0 5px 20px var(--shadow-color);\n  border-right: 4px solid transparent;\n  text-decoration: none;\n  color: inherit;\n  display: block;\n  transform-style: preserve-3d;\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.4s ease;\n}\n\n.region-card:hover {\n  transform: translateY(-8px) rotateX(4deg) rotateY(-3deg);\n  box-shadow: 0 22px 40px rgba(10, 37, 64, 0.2);\n}\n\n.region-card.interactive-lift::before {\n  background: var(--gradient-maritime);\n}\n\n.region-card h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 0.75rem;\n  font-size: 1.25rem;\n}\n\n.region-card p {\n  color: var(--footer-medium-gray);\n  line-height: 1.8;\n  margin: 0;\n}\n\n/* Borders Section - قسم المعابر */\n.borders-section {\n  padding: 80px 0;\n  background-color: var(--bg-white);\n}\n\n.borders-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.border-card {\n  background: linear-gradient(135deg, var(--section-light-gray) 0%, var(--bg-white) 100%);\n  padding: 0;\n  border-radius: 12px;\n  box-shadow: 0 5px 20px var(--shadow-color);\n  border-right: 4px solid var(--secondary-light-gold);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  overflow: hidden;\n}\n\n.border-card:hover {\n  transform: translateX(-5px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.border-card-image {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  position: relative;\n}\n\n.border-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.border-card:hover .border-card-image img {\n  transform: scale(1.1);\n}\n\n.border-card h3 {\n  color: var(--primary-dark-blue);\n  margin: 1.5rem 2.5rem 1.5rem;\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.border-card ul {\n  list-style: none;\n  padding: 0 2.5rem 2.5rem;\n}\n\n.border-card ul li {\n  padding: 0.8rem 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  color: var(--text-dark-gray);\n  position: relative;\n  padding-right: 1.5rem;\n}\n\n.border-card ul li::before {\n  content: '✓';\n  position: absolute;\n  right: 0;\n  color: var(--button-medium-blue);\n  font-weight: bold;\n}\n\n.border-card ul li:last-child {\n  border-bottom: none;\n}\n\n/* Contact Section - قسم الاتصال */\n.contact-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 3rem;\n  margin-top: 3rem;\n}\n\n.contact-info {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  height: fit-content;\n}\n\n.contact-info h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 2rem;\n  font-size: 1.5rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  color: var(--text-dark-gray);\n}\n\n.contact-icon {\n  font-size: 1.5rem;\n  width: 40px;\n  text-align: center;\n}\n\n/* Contact Form - نموذج الاتصال */\n.contact-form {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--primary-dark-blue);\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.form-hint {\n  display: block;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--footer-medium-gray);\n  font-style: italic;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px 15px;\n  border: 2px solid var(--section-light-gray);\n  border-radius: 5px;\n  font-size: 1rem;\n  font-family: inherit;\n  transition: border-color 0.3s ease;\n  background-color: var(--bg-white);\n  color: var(--text-dark-gray);\n}\n\n.form-group select {\n  font-size: 0.9rem !important;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.form-group select option {\n  font-size: 0.9rem !important;\n  padding: 0.4rem;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--button-medium-blue);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.contact-form .btn {\n  width: 100%;\n  margin-top: 1rem;\n}\n\n/* Responsive Design - التصميم المتجاوب */\n@media (max-width: 968px) {\n  .about-content-wrapper {\n    grid-template-columns: 1fr;\n  }\n\n  .about-images {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-title {\n    font-size: 3rem;\n  }\n\n  .hero-tagline {\n    font-size: 1.3rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 80px 0;\n  }\n\n  .hero-title {\n    font-size: 2.5rem;\n  }\n\n  .hero-tagline {\n    font-size: 1.1rem;\n  }\n\n  .hero-stats {\n    gap: 1.5rem;\n    padding: 1.5rem;\n    margin: 2rem 0;\n  }\n\n  .hero-stat-item {\n    min-width: 100px;\n  }\n\n  .hero-stat-number {\n    font-size: 2rem;\n  }\n\n  .hero-stat-label {\n    font-size: 0.9rem;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .hero-buttons .btn {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .about-logo-image {\n    max-width: 300px;\n    max-height: 150px;\n  }\n\n  .about-images {\n    grid-template-columns: 1fr;\n  }\n\n  .transport-image img {\n    height: 200px;\n  }\n\n  .about-section,\n  .services-section,\n  .borders-section,\n  .contact-section {\n    padding: 60px 0;\n  }\n\n  .services-grid,\n  .borders-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .service-card,\n  .border-card {\n    padding: 2rem;\n  }\n\n  .contact-info,\n  .contact-form {\n    padding: 2rem;\n  }\n}\n\n/* Statistics Section - قسم الإحصائيات */\n.statistics-section {\n  padding: 80px 0;\n  background: var(--gradient-primary);\n  color: var(--bg-white);\n  position: relative;\n  overflow: hidden;\n}\n\n.statistics-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1440 320\"><path fill=\"%23ffffff\" fill-opacity=\"0.05\" d=\"M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z\"></path></svg>') no-repeat bottom;\n  background-size: cover;\n  opacity: 0.3;\n}\n\n.statistics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 2.5rem;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n}\n\n.stat-item {\n  padding: 2.5rem 1.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.stat-item:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.stat-number {\n  font-size: 4rem;\n  font-weight: 700;\n  color: var(--secondary-light-gold);\n  margin-bottom: 0.75rem;\n  line-height: 1;\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);\n  display: block;\n}\n\n.stat-label {\n  font-size: 1.3rem;\n  color: var(--bg-white);\n  opacity: 0.95;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n/* Quick Quote Section - قسم طلب عرض سعر */\n.quick-quote-section {\n  padding: 80px 0;\n  background-color: var(--bg-white);\n}\n\n.quote-form {\n  max-width: 900px;\n  margin: 0 auto;\n  background-color: var(--section-light-gray);\n  padding: 3rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n}\n\n.quote-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.quote-form .form-group label {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.quote-form .form-group input {\n  font-size: 1rem;\n  padding: 12px 15px;\n}\n\n.quote-form .form-group select {\n  font-size: 0.9rem !important;\n  padding: 12px 15px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.quote-form .form-group select option {\n  font-size: 0.9rem !important;\n  padding: 0.4rem;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n/* Calculator Section - الآلة الحاسبة */\n.calculator-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.tariff-download-banner {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 2rem;\n  background: linear-gradient(135deg, var(--primary-dark-blue) 0%, var(--button-medium-blue) 100%);\n  border-radius: 10px;\n  color: var(--bg-white);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.tariff-download-banner p {\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n  color: var(--bg-white);\n}\n\n.tariff-download-banner .btn {\n  margin-top: 0.5rem;\n}\n\n/* Tariff Importer Section */\n.tariff-importer-section {\n  margin: 3rem 0;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.importer-details {\n  background-color: var(--bg-white);\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.importer-summary {\n  padding: 1.5rem;\n  background: linear-gradient(135deg, var(--primary-dark-blue) 0%, var(--button-medium-blue) 100%);\n  color: var(--bg-white);\n  font-weight: 600;\n  font-size: 1.1rem;\n  cursor: pointer;\n  list-style: none;\n  user-select: none;\n}\n\n.importer-summary::-webkit-details-marker {\n  display: none;\n}\n\n.importer-summary::before {\n  content: '▶';\n  display: inline-block;\n  margin-left: 0.5rem;\n  transition: transform 0.3s ease;\n}\n\n.importer-details[open] .importer-summary::before {\n  transform: rotate(90deg);\n}\n\n.importer-content {\n  padding: 2rem;\n}\n\n.import-instructions {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background-color: var(--section-light-gray);\n  border-radius: 8px;\n  border-right: 4px solid var(--button-medium-blue);\n}\n\n.import-instructions h4 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 1rem;\n}\n\n.import-instructions ol {\n  padding-right: 1.5rem;\n  color: var(--text-dark-gray);\n  line-height: 2;\n}\n\n.import-instructions li {\n  margin-bottom: 0.5rem;\n}\n\n.import-instructions strong {\n  color: var(--primary-dark-blue);\n}\n\n.calculator-container {\n  max-width: 800px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n.calculator-form {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n}\n\n.hs-search-group {\n  position: relative;\n}\n\n.hs-search-box {\n  position: relative;\n}\n\n.hs-suggestions {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 20;\n  max-height: 280px;\n  overflow-y: auto;\n  background: var(--bg-white);\n  border: 1px solid var(--border-light, #d0d7de);\n  border-radius: 8px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);\n}\n\n.hs-suggestion-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  background: transparent;\n  text-align: inherit;\n  cursor: pointer;\n  color: var(--text-dark-gray);\n}\n\n.hs-suggestion-item:last-child {\n  border-bottom: 0;\n}\n\n.hs-suggestion-item:hover,\n.hs-suggestion-item:focus {\n  background: rgba(0, 119, 182, 0.08);\n  outline: none;\n}\n\n.hs-suggestion-code {\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n\n.hs-suggestion-desc {\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--text-dark-gray);\n}\n\n.hs-suggestion-empty {\n  padding: 0.9rem 1rem;\n  color: var(--text-dark-gray);\n  opacity: 0.8;\n}\n\n.hs-search-hint,\n.hs-selected-desc,\n.hs-chapter-note {\n  margin: 0.55rem 0 0;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  color: var(--text-dark-gray);\n}\n\n.hs-selected-desc {\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n}\n\n.hs-chapter-note {\n  padding: 0.65rem 0.8rem;\n  background: rgba(0, 119, 182, 0.06);\n  border-radius: 6px;\n  border-right: 3px solid var(--button-medium-blue, #0077b6);\n}\n\n.dark-mode .hs-suggestions {\n  background: #1b2430;\n  border-color: #334155;\n}\n\n.dark-mode .hs-suggestion-item {\n  color: #e2e8f0;\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark-mode .hs-suggestion-item:hover,\n.dark-mode .hs-suggestion-item:focus {\n  background: rgba(56, 189, 248, 0.12);\n}\n\n.dark-mode .hs-suggestion-code,\n.dark-mode .hs-selected-desc {\n  color: #7dd3fc;\n}\n\n.dark-mode .hs-chapter-note {\n  background: rgba(56, 189, 248, 0.1);\n}\n\n.calculator-form .form-group select {\n  font-size: 0.9rem !important;\n  font-weight: 500;\n  padding: 12px 15px;\n  line-height: 1.4;\n}\n\n.calculator-form .form-group select option {\n  font-size: 0.9rem !important;\n  padding: 0.4rem;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.calculator-result {\n  background: var(--gradient-primary);\n  color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 8px 25px var(--shadow-color);\n  height: fit-content;\n}\n\n.calculator-result h3 {\n  color: var(--bg-white);\n  margin-bottom: 1.5rem;\n}\n\n.result-amount {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--secondary-light-gold);\n  margin-bottom: 1rem;\n}\n\n.result-amount.is-pulsing {\n  animation: goldPulse 0.85s var(--motion-ease) 1;\n}\n\n.hs-search-group .hs-search-box input:focus {\n  outline: none;\n  border-color: var(--accent-sky) !important;\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.22), 0 0 18px rgba(212, 175, 55, 0.18);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hero-wave-layer,\n  .result-amount.is-pulsing,\n  .transport-image img {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n.currency-label {\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-right: 0.5rem;\n  opacity: 0.9;\n}\n\n.result-note {\n  font-size: 0.9rem;\n  opacity: 0.9;\n  margin: 1rem 0 0 0;\n}\n\n.result-breakdown {\n  margin: 1.5rem 0;\n  padding: 1.5rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n}\n\n.breakdown-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.8rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.breakdown-item:last-child {\n  border-bottom: none;\n}\n\n.breakdown-item.breakdown-total {\n  font-weight: 600;\n  margin-top: 0.5rem;\n  padding-top: 1rem;\n  border-top: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.breakdown-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.breakdown-value {\n  color: var(--secondary-light-gold);\n  font-weight: 600;\n}\n\n\n/* Documents Section - دليل الوثائق */\n.documents-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.documents-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.document-card {\n  background-color: var(--bg-white);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  border-top: 4px solid var(--button-medium-blue);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.document-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n}\n\n.document-icon {\n  font-size: 3rem;\n  text-align: center;\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.document-card h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.document-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.document-card ul li {\n  padding: 0.8rem 0;\n  padding-right: 1.5rem;\n  position: relative;\n  color: var(--text-dark-gray);\n  border-bottom: 1px solid var(--section-light-gray);\n  font-size: 0.95rem;\n}\n\n.document-card ul li::before {\n  content: '✓';\n  position: absolute;\n  right: 0;\n  color: var(--button-medium-blue);\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.document-card ul li:last-child {\n  border-bottom: none;\n}\n\n/* Legacy support */\n.document-category {\n  background-color: var(--bg-white);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  border-top: 4px solid var(--button-medium-blue);\n}\n\n.document-category h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n}\n\n.document-category ul {\n  list-style: none;\n  padding: 0;\n}\n\n.document-category ul li {\n  padding: 0.8rem 0;\n  padding-right: 1.5rem;\n  position: relative;\n  color: var(--text-dark-gray);\n  border-bottom: 1px solid var(--section-light-gray);\n}\n\n.document-category ul li::before {\n  content: '📄';\n  position: absolute;\n  right: 0;\n}\n\n.document-category ul li:last-child {\n  border-bottom: none;\n}\n\n/* Borders Map - خريطة المعابر */\n.borders-map-container {\n  margin-bottom: 3rem;\n}\n\n.syria-map {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  background: linear-gradient(135deg, #e8f4f8 0%, #d4e8f0 100%);\n  border-radius: 10px;\n  margin: 0 auto;\n  border: 2px solid var(--button-medium-blue);\n}\n\n.map-point {\n  position: absolute;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.map-point:hover {\n  transform: scale(1.2);\n}\n\n.map-marker {\n  font-size: 2rem;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n.map-tooltip {\n  position: absolute;\n  bottom: 100%;\n  right: 50%;\n  transform: translateX(50%);\n  background-color: var(--primary-dark-blue);\n  color: var(--bg-white);\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.map-point:hover .map-tooltip {\n  opacity: 1;\n}\n\n.map-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  right: 50%;\n  transform: translateX(50%);\n  border: 5px solid transparent;\n  border-top-color: var(--primary-dark-blue);\n}\n\n/* Testimonials Section - شهادات العملاء */\n.testimonials-section {\n  padding: 80px 0;\n  background-color: var(--bg-white);\n}\n\n.testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.testimonial-card {\n  background-color: var(--section-light-gray);\n  padding: 2.5rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  border-right: 4px solid var(--secondary-light-gold);\n}\n\n.testimonial-rating {\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.testimonial-text {\n  color: var(--text-dark-gray);\n  line-height: 1.8;\n  margin-bottom: 1.5rem;\n  font-style: italic;\n}\n\n.testimonial-author {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.testimonial-author strong {\n  color: var(--primary-dark-blue);\n  font-size: 1.1rem;\n}\n\n.testimonial-author span {\n  color: var(--footer-medium-gray);\n  font-size: 0.9rem;\n}\n\n/* Certifications Section - الشهادات */\n.certifications-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.certifications-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.certification-item {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease;\n}\n\n.certification-item:hover {\n  transform: translateY(-5px);\n}\n\n.cert-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1rem;\n}\n\n.certification-item h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 0.5rem;\n}\n\n.certification-item p {\n  color: var(--footer-medium-gray);\n  margin: 0;\n}\n\n/* Partners Section - الشركاء */\n.partners-section {\n  padding: 80px 0;\n  background-color: var(--bg-white);\n}\n\n.partners-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.partner-logo {\n  background-color: var(--bg-white);\n  border-radius: 12px;\n  padding: 1.75rem 1.25rem;\n  text-align: center;\n  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.partner-logo:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);\n}\n\n.partner-emoji {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  background-color: var(--section-light-gray);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.25rem;\n}\n\n.partner-logo p {\n  margin: 0;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  line-height: 1.4;\n}\n\n/* Team Section - فريق العمل */\n.team-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  margin: 0;\n  position: relative;\n  /* منع تجمد الشاشة على Android */\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  /* منع التجميد على Android */\n  transform: none;\n  will-change: auto;\n  -webkit-transform: none;\n}\n\n.team-member {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease;\n  /* منع فتح القائمة عند اللمس */\n  touch-action: manipulation;\n  pointer-events: auto;\n}\n\n.team-member:hover {\n  transform: translateY(-5px);\n}\n\n/* على الموبايل: تعطيل hover effect */\n@media (max-width: 768px) {\n  .team-member:hover {\n    transform: none;\n  }\n  \n  .team-member {\n    touch-action: pan-y;\n    /* إزالة transition على الموبايل لمنع التجميد */\n    transition: none;\n  }\n  \n  /* منع تجمد الشاشة عند التمرير */\n  .team-section {\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    /* إزالة أي transform أو will-change */\n    transform: none;\n    will-change: auto;\n  }\n  \n  .team-grid {\n    /* تبسيط grid على الموبايل */\n    transform: none;\n    will-change: auto;\n  }\n}\n\n.member-avatar {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.team-member h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 0.5rem;\n}\n\n.member-role {\n  color: var(--button-medium-blue);\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.member-bio {\n  color: var(--footer-medium-gray);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* News Section - الأخبار */\n.news-section {\n  padding: 80px 0;\n  background-color: var(--bg-white);\n}\n\n.news-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.news-card {\n  background-color: var(--section-light-gray);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease;\n}\n\n.news-card:hover {\n  transform: translateY(-5px);\n}\n\n.news-date {\n  color: var(--button-medium-blue);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.news-card h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.news-card p {\n  color: var(--text-dark-gray);\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.news-link {\n  color: var(--button-medium-blue);\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.news-link:hover {\n  color: var(--primary-dark-blue);\n}\n\n/* FAQ Section - الأسئلة الشائعة */\n.faq-section {\n  padding: 80px 0;\n  background-color: var(--section-light-gray);\n}\n\n.faq-list {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.faq-item {\n  background-color: var(--bg-white);\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n}\n\n.faq-item:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.faq-question {\n  padding: 1.5rem;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--primary-dark-blue);\n  font-weight: 600;\n  transition: background-color 0.3s ease;\n}\n\n.faq-question:hover {\n  background-color: var(--section-light-gray);\n}\n\n.faq-icon {\n  font-size: 1.5rem;\n  color: var(--button-medium-blue);\n  font-weight: bold;\n  transition: transform 0.3s ease;\n}\n\n.faq-item.open .faq-icon {\n  transform: rotate(180deg);\n}\n\n.faq-answer {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease, padding 0.3s ease;\n  padding: 0 1.5rem;\n}\n\n.faq-item.open .faq-answer {\n  max-height: 500px;\n  padding: 0 1.5rem 1.5rem;\n}\n\n.faq-answer p {\n  color: var(--text-dark-gray);\n  line-height: 1.8;\n  margin: 0;\n}\n\n/* Responsive Design - التصميم المتجاوب */\n@media (max-width: 968px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-title {\n    font-size: 3rem;\n  }\n\n  .hero-tagline {\n    font-size: 1.3rem;\n  }\n\n  .calculator-container {\n    grid-template-columns: 1fr;\n  }\n\n  .quote-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 80px 0;\n  }\n\n  .hero-title {\n    font-size: 2.5rem;\n  }\n\n  .hero-tagline {\n    font-size: 1.1rem;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .hero-buttons .btn {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .about-section,\n  .services-section,\n  .borders-section,\n  .contact-section,\n  .statistics-section,\n  .quick-quote-section,\n  .calculator-section,\n  .documents-section,\n  .testimonials-section,\n  .certifications-section,\n  .partners-section,\n  .team-section,\n  .news-section,\n  .faq-section {\n    padding: 60px 0;\n  }\n\n  .services-grid,\n  .borders-grid,\n  .statistics-grid,\n  .testimonials-grid,\n  .certifications-grid,\n  .partners-grid,\n  .team-grid,\n  .news-grid,\n  .documents-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .service-card,\n  .border-card,\n  .contact-info,\n  .contact-form,\n  .quote-form,\n  .calculator-form {\n    padding: 2rem;\n  }\n\n  .stat-number {\n    font-size: 2.5rem;\n  }\n\n  .syria-map {\n    height: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero {\n    padding: 60px 0;\n  }\n\n  .about-logo-image {\n    max-width: 250px;\n    max-height: 125px;\n  }\n\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .hero-tagline {\n    font-size: 1rem;\n  }\n\n  .hero-stats {\n    gap: 1rem;\n    padding: 1rem;\n    margin: 1.5rem 0;\n  }\n\n  .hero-stat-item {\n    min-width: 80px;\n  }\n\n  .hero-stat-number {\n    font-size: 1.5rem;\n  }\n\n  .hero-stat-label {\n    font-size: 0.8rem;\n  }\n\n  .hero-buttons {\n    gap: 1rem;\n  }\n\n  .hero-buttons .btn {\n    padding: 10px 20px;\n    font-size: 0.9rem;\n  }\n\n  .section-title {\n    font-size: 1.75rem;\n  }\n\n  .stat-number {\n    font-size: 2rem;\n  }\n\n  .stat-label {\n    font-size: 1rem;\n  }\n}\n\n/* تحسينات خاصة لأندرويد */\n@media screen and (-webkit-min-device-pixel-ratio: 2) {\n  .hero-stats,\n  .stat-item {\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n  }\n}\n\n/* تحسينات خاصة لآبل */\n@supports (-webkit-touch-callout: none) {\n  .hero-stats,\n  .stat-item {\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n  }\n\n  body {\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* تحسينات للشاشات الصغيرة جداً */\n@media (max-width: 360px) {\n  .hero-title {\n    font-size: 1.75rem;\n  }\n\n  .hero-stats {\n    gap: 0.75rem;\n    padding: 0.75rem;\n  }\n\n  .hero-stat-number {\n    font-size: 1.25rem;\n  }\n\n  .hero-stat-label {\n    font-size: 0.75rem;\n  }\n\n  .hero-tagline {\n    font-size: 1rem;\n  }\n\n  .section-title {\n    font-size: 1.75rem;\n  }\n\n  .service-card,\n  .border-card,\n  .contact-info,\n  .contact-form,\n  .quote-form,\n  .calculator-form {\n    padding: 1.5rem;\n  }\n\n  .stat-number {\n    font-size: 2rem;\n  }\n\n  .stat-label {\n    font-size: 1rem;\n  }\n\n  .quote-form {\n    padding: 2rem 1.5rem;\n  }\n\n  .result-amount {\n    font-size: 2rem;\n  }\n\n  .syria-map {\n    height: 250px;\n  }\n}\n\n/* Dark Mode Styles - أنماط الوضع الداكن */\n.dark-mode .hero {\n  background: linear-gradient(135deg, #1a202c 0%, #2d3748 50%, #1a202c 100%);\n}\n\n.dark-mode .about-section,\n.dark-mode .services-section,\n.dark-mode .borders-section,\n.dark-mode .testimonials-section,\n.dark-mode .faq-section,\n.dark-mode .certifications-section,\n.dark-mode .news-section,\n.dark-mode .team-section,\n.dark-mode .partners-section,\n.dark-mode .quick-quote-section,\n.dark-mode .calculator-section,\n.dark-mode .documents-section {\n  background-color: var(--section-bg);\n  color: var(--text-dark-gray);\n}\n\n.dark-mode .about-content-wrapper,\n.dark-mode .service-card,\n.dark-mode .region-card,\n.dark-mode .border-card,\n.dark-mode .testimonial-card,\n.dark-mode .faq-item,\n.dark-mode .certification-card,\n.dark-mode .news-card,\n.dark-mode .team-member,\n.dark-mode .partner-logo,\n.dark-mode .document-card {\n  background-color: var(--section-light-gray);\n  border-color: var(--border-light);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.dark-mode .contact-info,\n.dark-mode .contact-form,\n.dark-mode .quote-form,\n.dark-mode .calculator-form {\n  background-color: var(--section-light-gray);\n  border-color: var(--border-light);\n}\n\n.dark-mode .form-group input,\n.dark-mode .form-group textarea,\n.dark-mode .form-group select {\n  background-color: var(--section-bg);\n  color: var(--text-dark-gray);\n  border-color: var(--border-light);\n}\n\n.dark-mode .form-group input:focus,\n.dark-mode .form-group textarea:focus,\n.dark-mode .form-group select:focus {\n  border-color: var(--accent-blue);\n  background-color: var(--section-bg);\n}\n\n.dark-mode .calculator-result {\n  background-color: var(--section-light-gray);\n  border-color: var(--border-light);\n}\n\n.dark-mode .result-amount {\n  color: var(--secondary-light-gold);\n}\n\n.dark-mode .breakdown-item {\n  border-color: var(--border-light);\n}\n\n.dark-mode .faq-question {\n  background-color: var(--section-light-gray);\n  color: var(--text-dark-gray);\n}\n\n.dark-mode .faq-answer {\n  background-color: var(--section-bg);\n  color: var(--text-medium-gray);\n}\n\n.dark-mode .about-logo-image {\n  filter: brightness(1.1);\n}\n\n.dark-mode .transport-image img,\n.dark-mode .border-card-image img {\n  opacity: 0.9;\n}\n\n.dark-mode .section-title {\n  color: var(--primary-dark-blue);\n}\n\n.dark-mode .section-subtitle {\n  color: var(--text-medium-gray);\n}\n\n.dark-mode .hero-stats {\n  background: rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(10px);\n}\n\n.dark-mode .tariff-download-banner {\n  background-color: var(--section-light-gray);\n  border-color: var(--border-light);\n}\n\n.dark-mode .json-preview-section {\n  background-color: var(--section-light-gray);\n  border-color: var(--border-light);\n}\n\n.dark-mode .json-preview-section pre {\n  background-color: var(--section-bg);\n  color: var(--text-dark-gray);\n}\n\n.dark-mode .importer-details {\n  background-color: var(--section-light-gray);\n  border-color: var(--border-light);\n}\n\n.dark-mode .importer-summary {\n  background-color: var(--section-light-gray);\n  color: var(--text-dark-gray);\n}\n\n.dark-mode .importer-content {\n  background-color: var(--section-bg);\n}\n\n.dark-mode .import-instructions {\n  background-color: var(--section-light-gray);\n  color: var(--text-dark-gray);\n}\n\n/* Extra maritime polish */\n.quote-form-glow {\n  position: relative;\n  border: 1px solid rgba(56, 189, 248, 0.18);\n  box-shadow: 0 12px 36px rgba(26, 54, 93, 0.1);\n}\n\n.document-card,\n.border-card,\n.testimonial-card,\n.news-card,\n.team-member,\n.partner-logo {\n  transition: transform 0.35s var(--motion-ease), box-shadow 0.35s ease;\n}\n\n.document-card:hover,\n.testimonial-card:hover,\n.news-card:hover,\n.team-member:hover,\n.partner-logo:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 16px 30px rgba(26, 54, 93, 0.14);\n}\n\n.certification-card {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  border-top: 4px solid var(--secondary-light-gold);\n  transition: transform 0.35s var(--motion-ease), box-shadow 0.35s ease;\n}\n\n.certification-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 16px 30px rgba(26, 54, 93, 0.14);\n}\n\n.certification-icon {\n  font-size: 3.2rem;\n  margin-bottom: 1rem;\n  display: block;\n  animation: floatSoft 3.6s ease-in-out infinite;\n}\n\n.map-point {\n  animation: mapPointPulse 2.4s ease-in-out infinite;\n}\n\n@keyframes mapPointPulse {\n  0%,\n  100% {\n    filter: drop-shadow(0 0 0 rgba(212, 175, 55, 0));\n  }\n  50% {\n    filter: drop-shadow(0 0 10px rgba(212, 175, 55, 0.55));\n  }\n}\n\n.calculator-form {\n  border: 1px solid rgba(56, 189, 248, 0.12);\n}\n\n.contact-form,\n.contact-info {\n  box-shadow: 0 12px 32px rgba(26, 54, 93, 0.08);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .certification-icon,\n  .map-point {\n    animation: none !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
